<template>
  <div>
    <div class="container">
      <comp-tab :data="[{ label: '人员管理', value: 0 }, { label: '角色管理', value: 1 }]" v-model="status" />
    </div>

    <div class="container">
      <el-row gutter="8">
        <el-col class="fr-jcfe" offset="20" span="4">
          <el-button @click="addRole" size="small" type="primary">添加角色</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column label="角色" prop="name" width="250" />
        <el-table-column label="权限" width="400">
          <template slot-scope="scope">
            <span v-if="scope.row.name != 'Admin'">
              <span style="margin-right: 8px;" v-for="item in scope.row.cansList" :key="item">{{ item }}</span>
            </span>
            <span v-if="scope.row.name == 'Admin'" style="margin-right: 8px;color:#ff4f4f">所有权限</span>
          </template>
        </el-table-column>
        <el-table-column label="员工数量" prop="storeadmincount" width="100" />
        <el-table-column label="更新时间" width="250">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.updatedat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.name == 'Admin'" @click="onEdit(scope.row)" size="small" type="text">修改</el-button>
            <el-button :disabled="scope.row.name == 'Admin'" @click="onDelete(scope.row)" size="small" type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';

export default {
  name: 'Roles',
  components: { 'comp-tab': Tab },
  watch: {
    status() {
      this.$router.replace('/setting/employee');
    }
  },
  data() {
    return {
      token: '',
      status: 1,
      list: []
    };
  },
  mounted() {
    this.token = getToken();
    this.getList();
  },
  methods: {
    async getList() {
      const res = await rpc(
        'StoreStoreRoleService.GetStoreRoleList',
        M('StoreRoleListQueryRequest', {
          token: M('Token', { token: this.token }),
          count: 100
        })
      );
      const ps = res.storerolelistList.map(v => {
        return rpc(
          'StoreStoreAdminService.GetStoreAdminList',
          M('StoreAdminListQueryRequest', {
            token: M('Token', { token: this.token }),
            storeroleid: v.id,
            count: 100
          })
        );
      });
      const reslist = await Promise.all(ps);
      res.storerolelistList.forEach((item, index) => (item.storeadmincount = reslist[index].storeadminlistList.length));
      this.list = res.storerolelistList;
    },
    onEdit({ id }) {
      this.$router.push({ name: 'setting-role-edit', query: { id: id } });
    },
    onDelete(row) {
      this.$confirm('确认删除？')
        .then(() => {
          rpc(
            'StoreStoreRoleService.DeleteStoreRole',
            M('IDWithTokenRequest', {
              token: M('Token', { token: this.token }),
              id: row.id
            })
          ).then(res => {
            this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          });
        })
        .catch(() => {});
    },
    addRole() {
      this.$router.push({ name: 'setting-role-edit' });
    }
  }
};
</script>

<style></style>
